(() => {
  'use strict';
  const initialiseJournal = (root) => {
    if (root.dataset.journalReady === 'true') return;
    const controls = root.querySelector('[data-journal-controls]');
    const stories = root.querySelector('[data-journal-stories]');
    const result = root.querySelector('[data-journal-results]');
    const cards = [...root.querySelectorAll('[data-journal-story]')];
    const buttons = [...root.querySelectorAll('[data-journal-filter]')];
    if (!controls || !stories || !result || !cards.length) return;
    root.dataset.journalReady = 'true';
    const topics = new Set(cards.map((card) => card.dataset.journalTopic));
    buttons.forEach((button) => {
      button.hidden = button.dataset.journalFilter !== 'all' && !topics.has(button.dataset.journalFilter);
      button.addEventListener('click', () => {
        const selected = button.dataset.journalFilter;
        let count = 0;
        cards.forEach((card) => {
          card.hidden = selected !== 'all' && card.dataset.journalTopic !== selected;
          if (!card.hidden) count += 1;
        });
        buttons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        stories.dataset.filtered = String(selected !== 'all');
        stories.dataset.count = String(count);
        const message = count === 1 ? root.dataset.resultsOne : root.dataset.resultsMany;
        result.textContent = message.replace('__count__', String(count));
      });
    });
    stories.dataset.filtered = 'false';
    stories.dataset.count = String(cards.length);
    const initialMessage = cards.length === 1 ? root.dataset.resultsOne : root.dataset.resultsMany;
    result.textContent = initialMessage.replace('__count__', String(cards.length));
    controls.hidden = false;
  };
  const initialiseWithin = (container) => {
    if (container.matches && container.matches('[data-journal-index]')) initialiseJournal(container);
    container.querySelectorAll('[data-journal-index]').forEach(initialiseJournal);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseWithin(document), { once: true });
  } else {
    initialiseWithin(document);
  }
  document.addEventListener('shopify:section:load', (event) => initialiseWithin(event.target));
})();
